import React from 'react';
import videoSample from '../Assets//videos/3d_printing_banner_video.mp4'; // Replace with actual video
import imgAutomation from '../Assets/Images/3d-rendering-industry-40-concept.jpg'; // Replace with actual image
import imgDesign from '../Assets/Images/composite-image-man-using-tablet-pc.jpg';
import imgProgramming from '../Assets/Images/team-welding-robots-movement-automotive-parts-industry.jpg';
import imgDFM from '../Assets/Images/engraving-details.jpg';

const Capabilities = () => {
  return (
    <div className="bg-white text-gray-800 pt-16 pb-10 px-6 lg:px-20">
      {/* Hero Section */}
      <div className="text-center mb-16">
        <h1 className="text-3xl lg:text-5xl font-bold text-[#fd8432] mb-4">Our Capabilities</h1>
        <p className="max-w-4xl mx-auto text-lg text-gray-600">Empowering innovation through intelligent engineering.</p>
      </div>

      {/* Vision / Mission / Values */}
      <div className="grid lg:grid-cols-3 gap-10 mb-20">
        <div className="p-6 border rounded-xl shadow-lg bg-[#f8f9fa]">
          <h2 className="text-xl font-bold mb-2 text-[#fd8432]">Vision</h2>
          <p className="text-gray-700 text-justify">
            To develop and deliver cutting-edge AI-based Design for Manufacturing (DFM) solutions that empower our customers to streamline their products with high-added value and innovative technological solutions through sustainable and competitive growth development processes and optimize manufacturing efficiency in a significantly reduced timeframe.
          </p>
        </div>

        <div className="p-6 border rounded-xl shadow-lg bg-[#f8f9fa]">
          <h2 className="text-xl font-bold mb-2 text-[#fd8432]">Mission</h2>
          <p className="text-gray-700 text-justify">
            We deliver global and innovative design and manufacturing solutions for the Automotive, MES, EV, Aeronautical, Infrastructure, and other industrial sectors, integrating advanced technologies such as robotics and artificial intelligence that together with human interaction contribute to more sustainable development.
          </p>
        </div>

        <div className="p-6 border rounded-xl shadow-lg bg-[#f8f9fa]">
          <h2 className="text-xl font-bold mb-2 text-[#fd8432]">Values</h2>
          <ul className="list-disc pl-4 text-gray-700">
            <li><strong>Customer Commitment:</strong> We build lasting relationships by exceeding expectations and adding value as partners.</li>
            <li><strong>Excellence in Execution:</strong> Our team's talent, perseverance, and leadership help us overcome challenges.</li>
            <li><strong>Agility:</strong> We adapt to globalization and market changes to exceed stakeholder expectations through our global and local presence.</li>
            <li><strong>Innovation:</strong> We focus on cutting-edge technologies to deliver high-value solutions and enhance our processes.</li>
          </ul>
        </div>
      </div>

      {/* Trusted Partner CTA */}
      <div className="text-center mb-16">
        <h2 className="text-2xl lg:text-3xl font-bold text-gray-800">
          Choose Us to Be Your Trusted Partner in <span className="text-[#fd8432]">Automation & Engineering Solutions</span>
        </h2>
      </div>

      {/* Capabilities Grid */}
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Automation & SPM */}
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-[#fd8432]">Automation & SPM Manufacturing</h3>
          <p className="text-gray-700">
            Designing and manufacturing custom automation systems and special-purpose machines for improved productivity and efficiency.
          </p>
        </div>
        <img src={imgAutomation} alt="Automation" className="rounded-lg shadow-md w-full h-auto" />

        {/* 3D Design */}
        <img src={imgDesign} alt="3D Design" className="rounded-lg shadow-md w-full h-auto order-last lg:order-none" />
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-[#fd8432]">3D Design & Engineering Consulting</h3>
          <p className="text-gray-700">
            End-to-end 3D design services, engineering consulting for product development, and optimization.
          </p>
        </div>

        {/* Programming */}
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-[#fd8432]">Programming & Control Systems</h3>
          <p className="text-gray-700">
            Expertise in PLC, HMI, and automation programming, ensuring smooth operation and integration with existing systems.
          </p>
        </div>
        <img src={imgProgramming} alt="Programming" className="rounded-lg shadow-md w-full h-auto" />

        {/* DFM */}
        <img src={imgDFM} alt="DFM" className="rounded-lg shadow-md w-full h-auto order-last lg:order-none" />
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-[#fd8432]">Quick DFM (Design for Manufacturing)</h3>
          <p className="text-gray-700">
            Fast and efficient DFM services to help clients optimize their designs for cost-effective and scalable production.
          </p>
        </div>
      </div>

      {/* Optional Video Section */}
      <div className="mt-20">
        <h2 className="text-2xl font-bold text-center mb-6 text-[#fd8432]">Experience Our Innovation</h2>
        <div className="max-w-4xl mx-auto rounded-xl overflow-hidden shadow-lg">
          <video controls autoPlay muted loop className="w-full h-auto">
            <source src={videoSample} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
};

export default Capabilities;
